export default "__VITE_ASSET___vRBEhA$__"